import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
declare global {
    interface Window {
        environments: any;
        alpha: {
            plugins: any;
            local: any;
            co: any;
            case_instance: any;
            task_instance: any;
            project: any;
            [key: string]: any;
        };
        ap: any;
        isAWSrunning: boolean;
    }
}
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
